import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { AutoCompleteModel } from "../models/auto-complete.model";
import { Observable, map, of } from "rxjs";

@Injectable()
export class AutoCompleteService {

    constructor(private apiService: ApiService) {

    }

    public getAutoComplete(term: string, type: string, casId: string) {

        if (term.length < 2) {
            return of([]);
        }

        const model: AutoCompleteModel = {
            text: term.toLowerCase(),
            type: type,
            casID: casId
        }

        return this.apiService.post<string[]>('autocomplete/get', model);
    }

}